angular.module('app').directive('colorUseCompareInIndustries', () => {
  let link = (scope) => {
    scope.filteredItem = {};
    scope.maxValuePercent = 1; 
    scope.$watch('colorData', function (newVal, prevVal) {
      if(newVal !== prevVal) {
        scope.colorData = newVal;
        scope.data = [];
      }
      bindData();
    });

    scope.widthDynamic = percent => {
      if (percent == 0){
        return 0
      } else if(percent > 0 && percent <= 1){
        return `calc(((100% - 87px) / 25) * 1 + 7px)`;
      } else if(percent > 1 && percent <= 5){
        return `calc((100% - 87px) / 25 * 5 + 25px)`;
      } else if(percent > 5 && percent <= 10){
        return `calc(((100% - 87px) / 25) * 10 + 49px)`;
      } else if(percent > 10 && percent <= 15){
        return `calc(((100% - 87px) / 25) * 15 + 75px)`;
      } else if(percent > 15 && percent <= 20){
        return `calc(((100% - 87px) / 25) * 20 + 100px)`;
      } else if(percent > 20 && percent <= 25){
        return `calc(((100% - 87px) / 25) * 25 + 74px)`;
      } else if(percent > 25){
        return `calc(((100% - 87px) / 25) * 25 + 74px)`;
      }
    }

    function bindData() {
      scope.data = scope.colorData.result.filter((item) => {
        return item.hex !== scope.colorData.color_percentage.hex;
      });

      scope.selectedItem = scope.colorData.color_percentage;
    }

    scope.numberWithCommas = (x) => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorUseCompareInIndustries/dbColorUseCompareInIndustriesView.html",
    link: link,
    scope: {
      colorData: "=",
      selectedColor: "=",
      colorHeaderData: "=",
      brandColorHeaderData: "=",
    }
  };
});
